import React, { useCallback, useEffect, useRef, useState } from "react";
import { env } from "@config";
import { getClassName } from "@utils";
import { useAppDispatch, useAppSelector } from "@store/hooks";
import { closeAboutModal } from "@store/global";
import { useClickOutside } from "@taskpane/hooks";
import { CrossIcon } from "@taskpane/icons";
import css from "./AboutModal.module.scss";

const AboutModal: React.FC = () => {
  const dispatch = useAppDispatch();

  const isOpenedValue = useAppSelector((state) => state.global.isAboutModalOpened);

  const [isOpened, setIsOpened] = useState(isOpenedValue);

  const containerRef = useRef<HTMLDivElement>(null);

  const handleClose = useCallback(() => {
    dispatch(closeAboutModal());
  }, [dispatch]);

  const attrs = {
    container: {
      ref: containerRef,
      className: getClassName(css.container, !isOpenedValue && css.containerClosing),
      onClick: handleClose,
      onAnimationEnd: () => {
        if (!isOpenedValue) {
          setIsOpened(false);
        }
      },
    },
    content: {
      className: css.content,
      onClick: (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
      },
    },
    row: {
      className: css.row,
    },
    crossButton: {
      type: "button" as const,
      className: css.crossButton,
      onClick: handleClose,
    },
    version: {
      className: css.version,
    },
    link: {
      className: css.link,
      href: "https://www.substrata.me/",
      target: "_blank",
      rel: "noopener noreferrer",
    },
    closeButton: {
      type: "button" as const,
      className: css.closeButton,
      onClick: handleClose,
    },
  };

  useEffect(() => {
    if (isOpenedValue) {
      setIsOpened(true);
    }
  }, [isOpenedValue]);

  useClickOutside(containerRef, handleClose);

  if (!isOpened) {
    return null;
  }

  return (
    <div {...attrs.container}>
      <div {...attrs.content}>
        <div {...attrs.row}>
          <span>Substrata Q for Email</span>
          <button {...attrs.crossButton}>
            <CrossIcon />
          </button>
        </div>
        <div {...attrs.version}>version {env.appVersion}</div>
        <div>
          <span>
            Visit the <a {...attrs.link}>Substrata Website</a> for more info.
          </span>
        </div>
        <button {...attrs.closeButton}>Close</button>
      </div>
    </div>
  );
};

export default AboutModal;
